import { useEffect } from "react";
import { GetPollById } from "../../Backend/ApiCalls"; // debe aceptar tokenOverride
import { exportSurveyToExcel, exportSurveyToPdf } from "../../utils/surveyExport";

export default function ExportarEncuesta() {
  useEffect(() => {
    const run = async () => {
      // --- BLOQUEA REDIRECCIONES DURANTE LA DESCARGA ---
      try {
        sessionStorage.setItem('suppressRedirect', '1');
        // cookie corta (2 min) por si Safari refresca la pestaña
        document.cookie = "skipRedirect=1; Max-Age=120; Path=/; SameSite=Lax";
      } catch {}

      const params = new URLSearchParams(window.location.search);
      const format = params.get("format"); // "xlsx" | "pdf"
      const id = params.get("id");
      const token = params.get("token") || localStorage.getItem("token") || "";

      if (!id || !format) {
        // limpieza mínima
        document.cookie = "skipRedirect=; Max-Age=0; Path=/";
        window.close?.();
        return;
      }

      // fetch encuesta con token de la query
      const { data: poll } = await GetPollById(id, { tokenOverride: token });

      // parse defensivo
      const questions = Array.isArray(poll.questions) ? poll.questions : JSON.parse(poll.questions || "[]");
      const voted = Array.isArray(poll.voted) ? poll.voted : JSON.parse(poll.voted || "[]");
      const paymentSummary = Array.isArray(poll.paymentSummary)
        ? poll.paymentSummary
        : typeof poll.paymentSummary === "string"
          ? JSON.parse(poll.paymentSummary || "{}")
          : poll.paymentSummary;
      const normalizedPoll = {
        ...poll,
        questions,
        voted,
        paymentSummary,
      };

      if (format === "xlsx") {
        await exportSurveyToExcel(voted, normalizedPoll);
      }

      if (format === "pdf") {
        await exportSurveyToPdf(voted, normalizedPoll);
      }


      // --- LIMPIEZA ---
      setTimeout(() => {
        try { document.cookie = "skipRedirect=; Max-Age=0; Path=/"; } catch {}
        // (opcional) cerrar la pestaña
        // window.close?.();
      }, 800);
    };
    run();
  }, []);

  return <div style={{ padding: 16 }}>Preparando tu descarga…</div>;
}
